import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const services = [
    {
        id: 1,
        header: 'CONSULTANCY',
        image: '/assets/northern_consuting.jpg',
        content: "We understand that every foodservice establishment is unique and operates differently from others. Aligned with the understanding and equipped with extensive experience in kitchen planning and consulting, our team of commercial kitchen experts can help you set up a customized commercial kitchen that meets the required standards of efficiency, quality and compliance. Our team of experienced kitchen consultants have an in-depth knowledge and hands on experience in the food services industry and are abreast with the latest developments in the field, which helps us ensure you get nothing but the best possible solution that is perfectly aligned with your needs.",
        subheading: "OUR CONSULTING SERVICES",
        details: ["Budget Estimating", "Cost Evaluation", "Bid Evaluation", "Equipment Selection"],
        additionalDescription: "Commercial kitchen design allotted space so that every square inch contributes to your company’s bottom line. When it comes to giving clients exactly what they need to make their commercial kitchen the right environment for achieving success in whatever industry they’re in, be it restaurants, café, school, hospitals, industrial camp, or any where else a kitchen is a necessity."
    },
    {
        id: 2,
        header: 'PROJECT MANAGEMENT',
        image: '/assets/northern_project_management.jpg',
        content: "Project Management is the anchor to a successful commercial kitchen project, as we know how difficult executing a commercial kitchen can be. And how costly it can be if construction details are missed or unnecessary delays are experienced. Our dedicated Project Managers provide immense value throughout the process, from contract to completion.",
        subheading: "OUR PROJECT MANAGEMENT SERVICES",
        details: ["Design & Sales Collaboration", "Project Planning", "Approvals & Signoff", "Sub Trade Management", "Delivery & Installation Scheduling", "Commissioning & Handover"],
        additionalDescription: "Our commercial kitchen project management aims to provide your business with the complete package, from start to finish."
    },
    {
        id: 3,
        header: 'FOOD SERVICE FACILITY DESIGN',
        image: '/assets/northern_design.jpg',
        content: "We Providing an independent and unbiased design that works best for your businesses needs, whether it be budgetary constraints, creative visions, food preparation processes for efficiency and much more. We can offer: Access to a vast archive of previous designs and plans. Enhanced visualisations that work with the chef and decision maker, but also highlight potential problems, making collaboration with architects structural engineers and other professionals more productive. Continued ongoing support throughout design with the option to change plans along the way when required. The chance to envisage yourself in your new premises, as well as staff and customers. Creating a space the kitchen staff but an atmosphere which has a positive impact on your diners.",
        subheading: "BENEFITS OF BFS DESIGN",
        details: ["Design Consultation & Full Site Survey", "Proposed CAD Layout Drawings", "Specification of All Equipment", "Full Technical Service Drawings"],
        additionalDescription: ""
    },
    {
        id: 4,
        header: 'EQUIPMENT SUPPLY & INSTALLATION',
        image: '/assets/northern_installation.jpg',
        content: "Choosing the correct commercial kitchen equipment is a crucial stage in your kitchen project. Your kitchen is only as good as the equipment inside it, and choosing the right pieces from the right brands is of the utmost importance. At Northern we only supply the highest quality equipment, using only industry recognised brands to ensure that your equipment performs tirelessly day after day. Our industry expertise, extensive supply chain and independent nature ensure that NORTHERN has access to all manufacturers and types of equipment so that we can specify the perfect installation solution for your brief and your desired menu, we can produce full detailed specifications for complete kitchen installation projects, or equipment. We provide Equipments, as well as preventative maintenance and support for various equipment from top brands.",
        subheading: "",
        details: [],
        additionalDescription: ""
    },
    {
        id: 5,
        header: 'STAINLESS STEEL FABRICATION',
        image: '/assets/northern_fabrication.jpg',
        content: "Our fabricators have extensive experience and expertise in working with stainless steel, delivering durable and functional kitchen equipment that meets high-quality standards. They are able to understand and execute precise specification ensuring the final product meets the Customer’s needs and expectations. Commercial Kitchen fabrication to meet the demands of the kitchen industry. Concept Fabrication offers a wide range of stainless steel off the shelf catering equipment items to fully manufactured kitchen solutions. We operate across the UAE offering a first class service including speedy delivery and professional installation.",
        subheading: "",
        details: ["Sink & Table Units", "Wall shelves", "Ambient Over Shelves", "Racking Units", "Pot Racks", "Dishwash Tabling", "Wall Cupboards", "Floor Cupboards", "Hot Cabinets", "Trolleys", "Bars Counter"],
        additionalDescription: "All of our fabricated commercial kitchen equipment items are designed and constructed to meet the highest expectations, so quality is never a concern."
    },
    {
        id: 6,
        header: 'AFTER SALES SERVICE & MAINTENANCE',
        image: '/assets/northern_service.jpg',
        content: "For commercial kitchen business owners, restaurant equipment problems can cause so many issues. When even one equipment breaksdown or fails to work as it should, it can have horrible effects on your business. We offers our customers with expert restaurant equipment repair and maintenance service that fits into your schedule. Our dedicated field team of technicians are equipped with service vans stocked with replacement parts to fix your commercial kitchen equipment on the first visit.",
        subheading: "WHAT WE OFFER",
        details: ["Cooking & Refrigeration Equipment Repair", "24/7 Emergency Repair", "Professional Team, Available at Your Location", "Annual Maintenance Contract (AMC)", "Installation Services", "Spare Parts Change"],
        additionalDescription: ""
    }
];

export default function ServiceDetails() {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    
    const { id } = useParams();
    const service = services.find((s) => s.id === parseInt(id));

    if (!service) {
        return <div className="text-center py-16 text-gray-600">Service not found</div>;
    }

    return (
        <div className="min-h-screen py-20 px-4 sm:px-6 lg:px-8 bg-gray-50 relative overflow-hidden">
            {/* Geometric Shapes Background */}
            <div className="absolute top-16 left-0 w-48 h-48">
                <div className="absolute top-8 left-8 w-24 h-24 bg-indigo-200 rounded-full opacity-30"></div>
                <div className="absolute top-4 left-4 w-16 h-16 bg-indigo-300 rounded-full opacity-30"></div>
                <div className="absolute top-12 left-2 w-12 h-12 bg-indigo-400 rounded-full opacity-30"></div>
            </div>
            <div className="absolute bottom-0 right-0 w-48 h-48">
                <div className="absolute bottom-8 right-8 w-24 h-24 bg-indigo-200 transform rotate-45 opacity-30"></div>
                <div className="absolute bottom-4 right-4 w-16 h-16 bg-indigo-300 transform rotate-45 opacity-30"></div>
            </div>

            {/* back button */} 
            <button className='hidden md:flex bg-indigo-900 hover:bg-indigo-950  gap-3 px-5 py-1 rounded-lg fixed left-16 top-20 cursor-pointer z-[100] text-white' onClick={()=>navigate(-1)} >
                <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-left"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0" /><path d="M5 12l4 4" /><path d="M5 12l4 -4" /></svg> Back 
            </button>

            <div className="max-w-4xl mx-auto relative z-10">
                {/* Heading */}
                <h1 className="md:text-4xl text-2xl font-bold text-indigo-900 mb-8 text-center">
                    {service.header}
                </h1>

                {/* Image */}
                <div className="mb-8">
                    <img
                        src={service.image}
                        alt={service.header}
                        className="w-full h-64 object-cover rounded-lg shadow-md"
                    />
                </div>

                {/* Subheading and Details (if available) */}
                {service.subheading && (
                    <div className="mb-8">
                        <h2 className="md:text-2xl text-xl font-semibold text-indigo-900 mb-4">
                            {service.subheading}
                        </h2>
                        <div className="flex flex-wrap gap-4">
                            {service.details.map((detail, index) => (
                                <span
                                    key={index}
                                    className="px-4 py-2 bg-indigo-100 text-indigo-900 text-sm font-medium rounded-full"
                                >
                                    {detail}
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {/* Main Content */}
                <p className="text-lg text-gray-700 leading-relaxed mb-8 text-start">
                    {service.content}
                </p>

                {/* Additional Description (if available) */}
                {/* {service.additionalDescription && (
          <p className="text-lg text-gray-700 leading-relaxed">
            {service.additionalDescription}
          </p>
        )} */}
            </div>
        </div>
    );
}